module.exports = __webpack_public_path__ + "media/images/it/icons/facebook-76f0d682935363edfe9b77268df7183c.svg";